
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"vuesax/twotone/filter","fill":"#697485"}},[_c('path',{attrs:{"d":"M4.951 1.237h12.1a2.524 2.524 0 012.521 2.521v2.016a4.131 4.131 0 01-1.118 2.594l-.031.029-3.943 3.484-.015.013a2.311 2.311 0 00-.669 1.58v3.942a2.715 2.715 0 01-1.148 2.142l-1.276.82-.011.007a2.524 2.524 0 01-1.324.374 2.637 2.637 0 01-1.764-.686 2.459 2.459 0 01-.8-1.832v-4.854a2.909 2.909 0 00-.566-1.475L3.45 8.271a3.7 3.7 0 01-1.02-2.313V3.85a2.541 2.541 0 012.521-2.613zm12.544 6.15a2.772 2.772 0 00.7-1.609v-2.02a1.147 1.147 0 00-1.144-1.146h-12.1A1.182 1.182 0 003.805 3.85v2.108a2.4 2.4 0 00.624 1.347l.012.013 3.483 3.669q.02.021.038.044a4.2 4.2 0 01.885 2.356v4.858a1.158 1.158 0 001.19 1.142 1.134 1.134 0 00.6-.167l1.277-.821.016-.012a1.406 1.406 0 00.491-.969v-3.943a3.644 3.644 0 011.159-2.63z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M5.5 9.854a.684.684 0 01-.363-.1.687.687 0 01-.219-.947l4.518-7.246a.687.687 0 01.947-.219.687.687 0 01.22.945L6.084 9.53a.687.687 0 01-.584.324z","opacity":".4"}})])])
          )
        }
      }
    